/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PositionCto } from '../../models/position-cto';

export interface GetJobsByCompanyAsync$Json$Params {
  companyId: string;
  positionNameFilter?: string;
}

export function getJobsByCompanyAsync$Json(http: HttpClient, rootUrl: string, params: GetJobsByCompanyAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PositionCto>>> {
  const rb = new RequestBuilder(rootUrl, getJobsByCompanyAsync$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.query('positionNameFilter', params.positionNameFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PositionCto>>;
    })
  );
}

getJobsByCompanyAsync$Json.PATH = '/job/company/{companyId}';
